import request from '@/router/axios'

const baseUrl = '/api/produce/emergency-drill-plan'

export const add = (data) => {
  return request({
    url: `${baseUrl}/insert`,
    method: 'post',
    data
  })
}

export const update = (data) => {
  return request({
    url: `${baseUrl}/update`,
    method: 'post',
    data
  })
}

export const getDetail = (id) => {
  return request({
    url: `${baseUrl}/select/id`,
    method: 'get',
    params: { id }
  })
}

export const getList = (data) => {
  return request({
    url: `${baseUrl}/select/page`,
    method: 'post',
    data
  })
}

export const remove = (id) => {
  return request({
    url: `${baseUrl}/delete/id`,
    method: 'get',
    params: { id }
  })
}

export const complete = (data) => {
  return request({
    url: `${baseUrl}/complete`,
    method: 'post',
    data
  })
}

export const downloadImportTemplate = () => {
  return request({
    url: `${baseUrl}/import-template`,
    method: 'get',
    responseType: 'blob'
  })
}

export const exportExcel = (data) => {
  return request({
    url: `${baseUrl}/export/excel`,
    method: 'post',
    data,
    responseType: 'blob'
  })
}
